import { render, staticRenderFns } from "./CollegeProfile.vue?vue&type=template&id=81a4b87e&scoped=true"
import script from "./CollegeProfile.vue?vue&type=script&lang=js"
export * from "./CollegeProfile.vue?vue&type=script&lang=js"
import style0 from "./CollegeProfile.vue?vue&type=style&index=0&id=81a4b87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a4b87e",
  null
  
)

export default component.exports